import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import {
    accordionTitleClassName,
    accordionTitleSlotClassNames,
    accordionContentClassName,
} from '@fluentui/react-northstar';

export const AccordionContainer: StyleRule = ({
    theme: { screen, siteVariables },
}) => ({
    minHeight: pxToRem(56),

    [`& .${accordionTitleClassName}`]: {
        cursor: 'pointer',
        borderTopWidth: '0px !important',
        paddingTop: '0 !important',
        paddingRight: '0 !important',
        paddingBottom: '0 !important',
        display: 'flex',
        flexGrow: 1,
        width: '100%',

        [screen.tablet]: {
            borderBottomWidth: '0px !important',
            borderTopWidth: '0px !important',
            borderColor: siteVariables.colors.primitive.black,
        },
    },
    [`& .${accordionTitleSlotClassNames.contentWrapper}`]: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        minHeight: pxToRem(56),
        paddingTop: '0 !important',

        // Inheritance title styles override
        '& > :last-child': {
            height: pxToRem(56),
            paddingTop: 0,
            paddingBottom: pxToRem(1),
            marginBottom: 0,
        },

        [screen.min.tablet]: {
            height: pxToRem(56),
        },
    },
    [`& .${accordionContentClassName}`]: {
        margin: 0,
        [screen.min.tablet]: {
            margin: pxArrayToRem([44, 0, 90, 0]),
        },
    },
    [screen.tablet]: {
        borderBottomWidth: '1px',
        borderColor: siteVariables.colors.primitive.black,
    },
});

export const AccordionTitle: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    letterSpacing: siteVariables.letterSpacingSmall,
    color: siteVariables.colors.charcoal[250],
    fontSize: pxToRem(16),
    lineHeight: siteVariables.lineHeightDefault,
    ...siteVariables.textStyles.Heading.Roman55,
    textTransform: 'uppercase',

    [screen.min.tablet]: {
        letterSpacing: siteVariables.letterSpacingMedium,
        fontSize: pxToRem(16),
        lineHeight: pxToRem(21),
    },
});

export const AccordionTitleWrapper: StyleRule<{ active: boolean }> = ({
    active,
    theme: { siteVariables },
}) => ({
    borderBottomWidth: `${active ? 0 : pxToRem(1)} !important`,
    borderColor: siteVariables.colors.primitive.black,
});

export const AccordionIcon: StyleRule = ({ theme: { screen } }) => ({
    position: 'relative',
    bottom: pxToRem(1),
    right: pxToRem(1),
    height: pxToRem(24),
    width: pxToRem(24),

    [screen.min.tablet]: {
        height: pxToRem(24),
        width: pxToRem(24),
    },
});

export const Downloads: StyleRule = () => ({
    scrollMarginTop: pxToRem(100),
});
